import { defineComponent as _defineComponent } from 'vue'
import './styles/list-legend.scss';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListLegend',
  props: {
  legends: {
    type: Array<{ label: string, sortable: boolean }>,
    default: []
  },
  isLoading: {
    type: Boolean, default: false
  },
  flexClass: {
    type: String,
    default: ''
  },
  legendsFlexStructure: {
    type: Array<string>,
    default: []
  }
},
  setup(__props) {

const props = __props;



let legendBarIsInViewport = false;

const outOfViewportStyle = 'box-shadow: none; background-color: transparent; margin: -1rem 0';

function visibilityChanged(isVisible: boolean) {
  legendBarIsInViewport = !isVisible;
}

return { __sfc: true,props, legendBarIsInViewport, outOfViewportStyle, visibilityChanged }
}

})